import axios from "axios";
import { config } from "../config";
import { getAuthHeader } from "../customAuth/authContext";
import { sleep } from "../infrastructures/utils";
import { DocumentPickerOption } from "../models/responses/ChatAssistantResponse";

export const getUserChatHistoryBySessionId = async (sessionId: string) => {
    let attempts = 0;
    const maxRetries = 3;
    const url = `${config.pythonApiUrl}/assistant/get-chat-history`;
    const request = { sessionId };

    while (attempts < maxRetries) {
        try {
            const response = await axios.get(url, {
                params: request,
                timeout: 600_000,
                headers: {
                    Authorization: getAuthHeader(),
                },
            });

            if (response?.status === 200) {
                return response?.data;
            }

        } catch (error) {
            console.error(`Error on attempt ${attempts + 1}:`, error);
        }

        attempts++;
        if (attempts < maxRetries) {
            await sleep(250 * attempts);
        }
    }

    console.error("All attempts failed or returned no data");
    return null;
}

export const getCollectionDocuments = async (collectionName: string): Promise<DocumentPickerOption[]> => {
    if (!collectionName) {
        return [];
    }

    try {
        const response = await axios.get(`${config.pythonApiUrl}/assistant/collection-documents`, {
            params: { collectionName },
            headers: {
                Authorization: getAuthHeader(),
            },
        });

        return (response.data?.result || [])
            .map((file: any) => ({
                filename: file.filename || file.FileName || "",
                hashcode: file.hashcode || file.Hashcode || "",
                status: file.status ?? file.Status ?? null,
            }))
            .filter((file: DocumentPickerOption) => file.filename && file.hashcode);
    } catch (error) {
        console.error("Error fetching collection documents:", error);
        return [];
    }
};
